import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=0b74c6e8&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=0b74c6e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74c6e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b74c6e8')) {
      api.createRecord('0b74c6e8', component.options)
    } else {
      api.reload('0b74c6e8', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=0b74c6e8&scoped=true&", function () {
      api.rerender('0b74c6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uDwREESTWCmT/JS/comp/Paginate.vue"
export default component.exports